<template>
    <div class="col-12">
        <div v-if="view == 'registration'" class="col-12 mb-50 mt-50">
            <div
                v-if="type === 'single'"
                v-for="(user, key) in users"
                class="mt-50"
            >
                <h4
                    class="title__divider title__divider--line font__size-21 font__weight-bold font__family-montserrat line__height-24 text-left"
                    data-brk-library="component__dividers"
                >
                    <span class="title__divider__wrapper"
                        >{{ $t("registration.racer") }}
                        <strong class="text-primary" id="text"
                            >{{ $t("registration.no") }} {{ key + 1 }}</strong
                        ></span
                    >

                    <button
                        class="btn btn-inside-out btn-sm btn-icon border-radius-25 font__family-open-sans font__weight-bold"
                        data-brk-library="component__button"
                        @click="removeUser(user)"
                        v-if="key"
                    >
                        <i
                            class="fa fa-times icon-inside"
                            aria-hidden="true"
                        ></i>
                        <span class="before">{{
                            $t("registration.remove")
                        }}</span>
                        <span class="text">{{
                            $t("registration.remove")
                        }}</span>
                        <span class="after">{{
                            $t("registration.remove")
                        }}</span>
                    </button>
                    <span class="line main-gradient-linear-2"></span>
                </h4>

                <div class="row mt-30 mb-3">
                    <div class="col-md-3">
                        <strong
                            v-if="errors['users.' + key + '.first_name']"
                        ></strong>
                        <input
                            type="text"
                            :placeholder="$t('registration.first_name')"
                            v-model="user.first_name"
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    errors['users.' + key + '.first_name']
                            }"
                            required
                        />
                        <span class="invalid-feedback" role="alert">
                            <strong
                                v-for="error in errors[
                                    'users.' + key + '.first_name'
                                ]"
                            >
                                {{ error }}</strong
                            >
                        </span>
                    </div>

                    <div class="col-md-3">
                        <input
                            type="text"
                            :placeholder="$t('registration.last_name')"
                            v-model="user.last_name"
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    errors['users.' + key + '.last_name']
                            }"
                            required
                        />
                        <span class="invalid-feedback" role="alert">
                            <strong
                                v-for="error in errors[
                                    'users.' + key + '.last_name'
                                ]"
                            >
                                {{ error }}</strong
                            >
                        </span>
                    </div>

                    <div class="col-md-3">
                        <datetime
                            v-model="user.date_of_birth"
                            input-class="form-control"
                            format="dd.MM.yyyy"
                            :placeholder="$t('registration.date_of_birth')"
                            @input="checkAge(user)"
                            required
                        >
                        </datetime>

                        <div
                            v-show="errors['users.' + key + '.date_of_birth']"
                            class="invalid"
                        >
                            <strong
                                v-for="error in errors[
                                    'users.' + key + '.date_of_birth'
                                ]"
                            >
                                {{ error }}</strong
                            >
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-check form-check-inline">
                            <input
                                class="form-check-input"
                                type="radio"
                                :id="'male-' + key"
                                v-model="user.gender"
                                value="male"
                            />
                            <label
                                class="form-check-label"
                                :for="'male-' + key"
                                >{{ $t("registration.male") }}</label
                            >
                        </div>

                        <div class="form-check form-check-inline">
                            <input
                                class="form-check-input"
                                type="radio"
                                :id="'female-' + key"
                                v-model="user.gender"
                                value="female"
                            />
                            <label
                                class="form-check-label"
                                :for="'female-' + key"
                                >{{ $t("registration.female") }}</label
                            >
                        </div>

                        <div
                            v-show="errors['users.' + key + '.gender']"
                            class="invalid"
                        >
                            <strong
                                v-for="error in errors[
                                    'users.' + key + '.gender'
                                ]"
                            >
                                {{ error }}</strong
                            >
                        </div>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-md-3">
                        <v-select
                            v-model="user.country_id"
                            :value="countries[56]"
                            label="name"
                            class="form-control"
                            :placeholder="$t('registration.state')"
                            :options="countries"
                            :class="{
                                'is-invalid':
                                    errors['users.' + key + '.country_id']
                            }"
                            :reduce="countries => countries.id"
                            :required="user.country_id"
                        >
                        </v-select>

                        <div
                            v-show="errors['users.' + key + '.country_id']"
                            class="invalid"
                        >
                            <strong
                                v-for="error in errors[
                                    'users.' + key + '.country_id'
                                ]"
                            >
                                {{ error }}</strong
                            >
                        </div>
                    </div>

                    <div class="col-md-3">
                        <input
                            type="text"
                            :placeholder="$t('registration.address')"
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    errors['users.' + key + '.address']
                            }"
                            v-model="user.address"
                            required
                        />
                        <span class="invalid-feedback" role="alert">
                            <strong
                                v-for="error in errors[
                                    'users.' + key + '.address'
                                ]"
                            >
                                {{ error }}</strong
                            >
                        </span>
                    </div>

                    <div class="col-md-3">
                        <input
                            type="text"
                            :placeholder="$t('registration.city')"
                            class="form-control"
                            :class="{
                                'is-invalid': errors['users.' + key + '.city']
                            }"
                            v-model="user.city"
                            required
                        />
                        <span class="invalid-feedback" role="alert">
                            <strong
                                v-for="error in errors[
                                    'users.' + key + '.city'
                                ]"
                            >
                                {{ error }}</strong
                            >
                        </span>
                    </div>

                    <div class="col-md-3">
                        <input
                            type="text"
                            class="form-control"
                            :class="{
                                'is-invalid': errors['users.' + key + '.postal']
                            }"
                            v-model="user.postal"
                            @input="checkIfLocal(user)"
                            :placeholder="$t('registration.postal')"
                            required
                        />
                        <span class="invalid-feedback" role="alert">
                            <strong
                                v-for="error in errors[
                                    'users.' + key + '.postal'
                                ]"
                            >
                                {{ error }}</strong
                            >
                        </span>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-md-3">
                        <input
                            type="email"
                            class="form-control"
                            :class="{
                                'is-invalid': errors['users.' + key + '.email']
                            }"
                            v-model="user.email"
                            :placeholder="$t('registration.email')"
                        />

                        <span class="invalid-feedback" role="alert">
                            <strong
                                v-for="error in errors[
                                    'users.' + key + '.email'
                                ]"
                            >
                                {{ error }}</strong
                            >
                        </span>
                    </div>

                    <div class="col-md-3">
                        <vue-tel-input
                            v-model="user.phone"
                            :dynamicPlaceholder="false"
                            :required="true"
                            class="form-control"
                            :inputOptions="{ showDialCode: true, tabindex: 2 }"
                            :placeholder="$t('registration.phone')"
                        ></vue-tel-input>

                        <span class="invalid-feedback" style="display: block">
                            <strong
                                v-for="error in errors[
                                    'users.' + key + '.phone'
                                ]"
                            >
                                {{ error }}</strong
                            >
                        </span>
                    </div>
                    <div class="col-md-3">
                        <select
                            name="tshirt"
                            class="form-control"
                            v-model="user.shirt_size"
                        >
                            <option value="" disabled>{{
                                $t("registration.shirt_size")
                            }}</option>
                            <option value="XS">XS</option>
                            <option value="S">S</option>
                            <option value="M">M</option>
                            <option value="L">L</option>
                            <option value="XL">XL</option>
                            <option value="XXL">XXL</option>
                        </select>

                        <div
                            v-show="errors['users.' + key + '.shirt_size']"
                            class="invalid"
                        >
                            <strong
                                v-for="error in errors[
                                    'users.' + key + '.shirt_size'
                                ]"
                            >
                                {{ error }}</strong
                            >
                        </div>
                    </div>

                    <div class="col-md-3">
                        <input
                            type="text"
                            class="form-control"
                            :class="{
                                'is-invalid': errors['users.' + key + '.club']
                            }"
                            v-model="user.club"
                            :placeholder="$t('registration.club_name')"
                        />
                        <div
                            v-show="errors['users.' + key + '.club']"
                            class="invalid"
                        >
                            <strong
                                v-for="error in errors[
                                    'users.' + key + '.club'
                                ]"
                            >
                                {{ error }}</strong
                            >
                        </div>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-md-3">
                        <input
                            type="text"
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    errors[
                                        'users.' + key + '.emergency_contact'
                                    ]
                            }"
                            v-model="user.emergency_contact"
                            :placeholder="$t('registration.emergency_contact')"
                        />

                        <span class="invalid-feedback" role="alert">
                            <strong
                                v-for="error in errors[
                                    'users.' + key + '.emergency_contact'
                                ]"
                            >
                                {{ error }}</strong
                            >
                        </span>
                    </div>

                    <div class="col-md-3">
                        <input
                            type="text"
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    errors[
                                        'users.' +
                                            key +
                                            '.emergency_contact_name'
                                    ]
                            }"
                            v-model="user.emergency_contact_name"
                            :placeholder="
                                $t('registration.emergency_contact_name')
                            "
                        />

                        <div
                            v-show="
                                errors[
                                    'users.' + key + '.emergency_contact_name'
                                ]
                            "
                            class="invalid"
                        >
                            <strong
                                v-for="error in errors[
                                    'users.' + key + '.emergency_contact_name'
                                ]"
                            >
                                {{ error }}</strong
                            >
                        </div>
                    </div>
                </div>

                <div class="row mt-3" v-if="user.minor">
                    <div class="col-md-3">
                        <input
                            type="text"
                            :placeholder="$t('registration.parent_name')"
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    errors[
                                        'users.' + key + '.parents.first_name'
                                    ]
                            }"
                            v-model="user.parents.first_name"
                        />
                        <span class="invalid-feedback" role="alert">
                            <strong
                                v-for="error in errors[
                                    'users.' + key + '.parents.first_name'
                                ]"
                            >
                                {{ error }}</strong
                            >
                        </span>
                    </div>

                    <div class="col-md-3">
                        <input
                            type="text"
                            class="form-control"
                            :placeholder="$t('registration.parent_lastname')"
                            :class="{
                                'is-invalid':
                                    errors[
                                        'users.' + key + '.parents.last_name'
                                    ]
                            }"
                            v-model="user.parents.last_name"
                        />
                        <span class="invalid-feedback" role="alert">
                            <strong
                                v-for="error in errors[
                                    'users.' + key + '.parents.last_name'
                                ]"
                            >
                                {{ error }}</strong
                            >
                        </span>
                    </div>

                    <div class="col-md-3">
                        <input
                            type="email"
                            :placeholder="$t('registration.parent_mail')"
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    errors['users.' + key + '.parents.email']
                            }"
                            v-model="user.parents.email"
                        />
                        <span class="invalid-feedback" role="alert">
                            <strong
                                v-for="error in errors[
                                    'users.' + key + '.parents.email'
                                ]"
                            >
                                {{ error }}</strong
                            >
                        </span>
                    </div>

                    <div class="col-md-3">
                        <vue-tel-input
                            v-model="user.parents.phone"
                            class="form-control"
                            :dynamicPlaceholder="false"
                            :inputOptions="{ showDialCode: true, tabindex: 2 }"
                            :placeholder="$t('registration.parent_phone')"
                        ></vue-tel-input>

                        <span
                            class="invalid-feedback"
                            style="display: block"
                            role="alert"
                        >
                            <strong
                                v-for="error in errors[
                                    'users.' + key + '.parents.phone'
                                ]"
                            >
                                {{ error }}</strong
                            >
                        </span>
                    </div>
                </div>

                <div class="row mt-40">
                    <div class="col-12 mb-30">
                        <h4
                            class="title__divider title__divider--line font__size-21 font__weight-light text-uppercase font__family-montserrat line__height-24 text-left"
                            data-brk-library="component__dividers"
                        >
                            <span
                                class="title__divider__wrapper text-uppercase font__weight-bold"
                            >
                                {{ $t("registration.select") }}
                                {{ $t("registration.package") }}
                                {{ $t("registration.racer") }}
                                <strong class="text-primary"
                                    >{{ $t("registration.no") }}
                                    {{ key + 1 }}</strong
                                >
                                <span
                                    class="line main-gradient-linear-2"
                                ></span>
                            </span>
                        </h4>
                    </div>

                    <div
                        :class="
                            user.products.includes(product)
                                ? 'product_border col-md-2 col-sm-4 col-xs-4 product_container  products_desktop'
                                : 'col-md-2 col-sm-4 col-xs-4 product_container products_desktop'
                        "
                        v-for="product in products"
                        @click="addProduct(user, product)"
                        v-if="product.id == 29"
                    >
                        <img
                            class="product_img pl-2 pt-3"
                            :src="'/storage/' + product.image"
                            alt=""
                        />
                        <p class="text-center font__size-14 font__weight-bold">
                            {{ product.name }}
                            <br />
                            <span
                                v-if="user.products.includes(product)"
                                class="text-success "
                                >SELECTED</span
                            >
                        </p>

                        <p
                            class="mt-2 butt on text-center font__size-14 font__family-montserrat uppercase text-primary"
                            v-if="user.products.includes(product)"
                        >
                            <span
                                class="text-white"
                                v-for="price in product.prices"
                                v-if="price.price_hrk"
                            >
                                {{ $t("registration.selected") }}
                            </span>
                            <span class="text-white" v-else>
                                FREE
                            </span>
                        </p>
                    </div>
                </div>

                <div
                    v-show="errors['users.' + key + '.products']"
                    class="invalid ml-4 mt-2 text-center"
                >
                    <strong
                        class="font__family-montserrat font__size-22 font__weight-bold text-center"
                        v-for="error in errors['users.' + key + '.products']"
                    >
                        <i class="fas fa-exclamation-circle fa-spin-fast"></i>
                        {{ error }}
                    </strong>
                </div>

                <div class="col col-12">
                    <ul
                        class="list-inline-4 products_mobile"
                        data-brk-library="component__list"
                    >
                        <li
                            class="font__family-montserrat font__size-16"
                            :class="
                                user.products.includes(product)
                                    ? ' active'
                                    : 'before'
                            "
                            v-for="product in products"
                            @click="addProduct(user, product)"
                            v-if="product.id == 29"
                        >
                            <span
                                :class="
                                    user.products.includes(product)
                                        ? 'before active'
                                        : 'before'
                                "
                            ></span>
                            <span class=" font__weight-bold">{{
                                product.name
                            }}</span>
                            <br />

                            <small
                                v-if="product.prices[0]"
                                class="font__size-14 "
                            >
                                {{ product.prices[0].name }} -
                                <span class="font__weight-bold">
                                    {{ product.prices[0].price_hrk }} € | $
                                    {{ product.prices[0].price_usd }} |
                                    {{ product.prices[0].price_eur }} &euro;
                                </span>
                            </small>
                        </li>
                    </ul>
                </div>
            </div>
            <!--

                <div class="col-12 mt-40">
                    <p v-for="product in user.products" v-if="product.prices[0]">
                        <span class="font__weight-bold">
                            {{ product.name }} -
                        </span>

                        <span class="font__weight-bold text-primary">
                        {{ product.prices[0].name }}:
                          {{  product.prices[0].price_hrk }} Kn |
                    $ {{ product.prices[0].price_usd }} |
                    {{ product.prices[0].price_eur }} &euro;
                                              </span>
                        <br>
                    </p>
                </div>
                            <div class="row">

                                <div class="col-md-6 mt-5">

                                     <multiselect v-model="user.products"
                                                    :options="products"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    :clear-on-select="false"
                                                    :preserve-search="true"
                                                    :placeholder="$t('registration.chose_ticket')"
                                                    label="name"
                                                    track-by="name"
                                                    :option-height="104"
                                                    class="form-control"
                                       >
                                           <template slot="singleLabel" slot-scope="props">
                                               <img class="option__image"
                                                    :src="'/storage/' + props.option.image"
                                                    width="100px">

                                               <span class="option__desc">
                                                   <span class="option__title">{{ props.option.title }} <br> {{ props.option.price}}</span>
                                               </span>
                                           </template>

                                           <template slot="option" slot-scope="props">
                                               <img class="option__image"
                                                    :src="'/storage/' + props.option.image"
                                                    width="100px">

                                               <div class="option__desc">
                                                   <span class="option__title">{{ props.option.name }}  <br> {{ props.option.price}} Kn</span>
                                               </div>
                                           </template>
                                       </multiselect>

                                </div>
                            </div>
            -->
        </div>

        <section class="btn-box delimiter pt-20">
            <div class="container">
                <div class="delimiter-box delimiter__delimiter-solid-gradient">
                    <span class="before"></span>
                    <button
                        class="btn btn-inside-out btn-md border-radius-25 font__family-open-sans font__weight-bold"
                        data-brk-library="component__button"
                        @click="addUser()"
                    >
                        <span class="before">{{
                            $t("registration.add_racer")
                        }}</span>
                        <span class="text">{{
                            $t("registration.add_racer")
                        }}</span>
                        <span class="after">{{
                            $t("registration.add_racer")
                        }}</span>
                    </button>
                </div>
            </div>
        </section>

        <h4
            class=" mt-40  mb-40 title__divider title__divider--line font__size-21 font__weight-bold font__family-montserrat line__height-24 text-left"
            data-brk-library="component__dividers"
        >
            <span class="title__divider__wrapper"
                >{{ $t("pool.title") }}

                <span class="line brk-base-bg-gradient-right"></span
            ></span>
        </h4>

        <div class="row" id="poll" v-if="this.users[0].du == 0">
            <div class="col-md-3">
                <datetime
                    v-model="poll.arrival_date"
                    input-class="form-control"
                    format="dd.MM.yyyy"
                    min-datetime="2020-09-01"
                    max-datetime="2020-10-31"
                    :placeholder="$t('registration.arrival_date')"
                    requred
                >
                </datetime>
                <div v-show="errors['poll.arrival_date']" class="invalid">
                    <strong v-for="error in errors['poll.arrival_date']">
                        {{ error }}</strong
                    >
                </div>
            </div>

            <div class="col-md-3">
                <datetime
                    v-model="poll.departure_date"
                    input-class="form-control"
                    min-datetime="2020-09-01"
                    max-datetime="2020-10-31"
                    format="dd.MM.yyyy"
                    :placeholder="$t('registration.departure_date')"
                >
                </datetime>

                <div v-show="errors['poll.departure_date']" class="invalid">
                    <strong v-for="error in errors['poll.departure_date']">
                        {{ error }}</strong
                    >
                </div>
            </div>

            <div class="col-md-3">
                <select
                    name="transport"
                    class="form-control"
                    v-model="poll.transport"
                >
                    <option value="" disabled>
                        {{ $t("registration.transport") }}</option
                    >
                    <option value="airplane">{{ $t("pool.airplane") }}</option>
                    <option value="boat">{{ $t("pool.boat") }}</option>
                    <option value="bus">{{ $t("pool.bus") }}</option>
                    <option value="car">{{ $t("pool.car") }}</option>
                    <option value="other">{{ $t("pool.other") }}</option>
                </select>

                <div v-show="errors['poll.transport']" class="invalid">
                    <strong v-for="error in errors['poll.transport']">
                        {{ error }}</strong
                    >
                </div>
            </div>

            <div class="col-md-3">
                <select
                    name="accomodation"
                    class="form-control"
                    v-model="poll.accommodation"
                >
                    <option value="" disabled>{{
                        $t("pool.accommodation")
                    }}</option>
                    <option value="hotel">{{ $t("pool.hotel") }}</option>
                    <option value="private">{{ $t("pool.private") }}</option>
                    <option value="camp">{{ $t("pool.camp") }}</option>
                    <option value="family">{{ $t("pool.family") }}</option>
                    <option value="other">{{ $t("pool.other") }}</option>
                </select>

                <div v-show="errors['poll.accommodation']" class="invalid">
                    <strong v-for="error in errors['poll.accommodation']">
                        {{ error }}</strong
                    >
                </div>
            </div>
        </div>

        <div class="row mt-3 mb-2">
            <div class="col-md-3" v-if="this.users[0].du == 0">
                <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors['poll.passengers'] }"
                    v-model="poll.passengers"
                    :placeholder="$t('registration.passengers')"
                />

                <span class="invalid-feedback" role="alert">
                    <strong v-for="error in errors['poll.passengers']">
                        {{ error }}</strong
                    >
                </span>
            </div>

            <div class="col-md-9">
                <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors['poll.note'] }"
                    v-model="poll.note"
                    :placeholder="$t('registration.question')"
                />

                <span class="invalid-feedback" role="alert">
                    <strong v-for="error in errors['poll.note']">
                        {{ error }}</strong
                    >
                </span>
            </div>
        </div>
        <div class="row mt-3 mb-2" v-if="this.users[0].du == 0">
            <div class="col-md-6">
                <select name="about" class="form-control" v-model="poll.about">
                    <option value="" disabled>{{
                        $t("about_us.placeholder")
                    }}</option>
                    <option value="web site">{{
                        $t("about_us.web_site")
                    }}</option>
                    <option value="social networks">{{
                        $t("about_us.social_network")
                    }}</option>
                    <option value="acquaintance">{{
                        $t("about_us.acquaintance")
                    }}</option>
                    <option value="club">{{ $t("about_us.club") }}</option>
                    <option value="media">{{ $t("about_us.media") }}</option>
                </select>
                <div v-show="errors['poll.about']" class="invalid">
                    <strong v-for="error in errors['poll.about']">
                        {{ error }}</strong
                    >
                </div>
            </div>
            <div class="col-md-6" v-if="this.users[0].du == 0">
                <select
                    name="experience"
                    class="form-control"
                    v-model="poll.experience"
                >
                    <option value="" disabled>{{
                        $t("experience.placeholder")
                    }}</option>
                    <option value="wine routes">{{
                        $t("experience.wine_routes")
                    }}</option>
                    <option value="old town">{{
                        $t("experience.old_town")
                    }}</option>
                    <option value="dubrovnik islands">{{
                        $t("experience.dubrvnik_islands")
                    }}</option>
                    <option value="relax and swim">{{
                        $t("experience.relax")
                    }}</option>
                    <option value="gastronomy">{{
                        $t("experience.gastronomy")
                    }}</option>
                </select>
                <div v-show="errors['poll.experience']" class="invalid">
                    <strong v-for="error in errors['poll.experience']">
                        {{ error }}</strong
                    >
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <input
                type="checkbox"
                class="mt-15 ml-20"
                name="privacy"
                id="privacy"
                v-model="privacy"
            />
            <label
                class="ml-10 mt-10"
                for="privacy"
                v-html="$t('registration.gdpr_josipov')"
            >
            </label>
        </div>

        <span class="text-danger font__size-12" role="alert">
            <strong v-for="error in errors['privacy']">
                {{ error }}</strong
            ></span
        >

        <div class="mt-30">
            <button
                class="btn btn-inside-out btn-lg btn-icon border-radius-25 font__family-open-sans font__weight-bold"
                data-brk-library="component__button"
                @click="register()"
            >
                <span class="before">{{ $t("registration.register") }}</span>
                <span class="text">{{ $t("registration.register") }}</span>
                <span class="after">{{ $t("registration.register") }}</span>
            </button>
        </div>
        <gtm-event :order="'order'" :event="'event'"></gtm-event>
    </div>
</template>

<script>
export default {
    mounted() {
        this.setlang();
        let count = this.getCountries();
        this.getProducts();
        // this.$gtm.trackView('Registration', '/registration');
    },

    data() {
        return {
            lang: "",
            view: "registration",
            type: "single",
            countries: [],
            products: [],
            errors: {},
            privacy: false,
            users: [
                {
                    first_name: "",
                    last_name: "",
                    date_of_birth: "",
                    gender: "",
                    country_id: "",
                    address: "",
                    city: "",
                    postal: "",
                    shirt_size: "",
                    club: "",
                    emergency_contact: "",
                    emergency_contact_name: "",
                    email: "",
                    phone: "",
                    minor: "",
                    du: 0,
                    products: [],
                    parents: {
                        first_name: "",
                        last_name: "",
                        email: "",
                        phone: ""
                    }
                }
            ],

            newUser: {
                first_name: "",
                last_name: "",
                date_of_birth: "",
                gender: "",
                country_id: "",
                address: "",
                city: "",
                postal: "",
                shirt_size: "",
                club: "",
                emergency_contact: "",
                emergency_contact_name: "",
                email: "",
                minor: "",
                du: 0,
                phone: "",
                products: [],
                parents: {
                    first_name: "",
                    last_name: "",
                    email: "",
                    phone: ""
                }
            },

            poll: {
                arrival_date: "",
                departure_date: "",
                transport: "",
                accommodation: "",
                passengers: "",
                note: "",
                about: "",
                experience: ""
            }
        };
    },

    methods: {
        setlang() {
            this.$i18n.locale = window.default_locale;
            this.lang = window.default_locale;
        },

        onUpdatePhone(data) {
            console.log(data);
        },

        addUser() {
            let user = this.newUser;
            user.city = this.users[0].city;
            user.postal = this.users[0].postal;
            user.products = [];
            user.country_id = this.users[0].country_id;
            user.emergency_contact = this.users[0].emergency_contact;
            user.emergency_contact_name = this.users[0].emergency_contact_name;
            user.club = this.users[0].club;

            this.users.push(Object.assign({}, user));
        },

        removeUser(user) {
            this.users.splice(this.users.indexOf(user), 1);
        },

        getCountries() {
            axios.get("/api/v1/service/countries").then(response => {
                let croatia;
                this.countries = response.data.countries;
                if (this.lang == "hr") {
                    this.countries.forEach(function(element, index, object) {
                        if (element.code == "HR") {
                            croatia = Object.assign(element);
                            object.splice(index, 1);
                        }
                    });
                    this.countries.unshift(croatia);
                }
            });
        },

        getProducts() {
            axios
                .get("/api/v1/service/products?lang=" + this.lang)
                .then(response => {
                    this.products = response.data.products;
                });
        },

        getPrices() {
            axios
                .get("/admin/products-prices/" + this.product)
                .then(response => {
                    this.prices = response.data;
                });
        },

        checkIfLocal(user) {
            console.log(user);
            if (user.country_id == 56 && user.postal.startsWith("20")) {
                this.users[this.users.indexOf(user)].du = 1;
            } else {
                this.users[this.users.indexOf(user)].du = 0;
            }
        },

        checkAge(user) {
            var today = new Date();
            var birthDate = new Date(user.date_of_birth);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            this.users[this.users.indexOf(user)].minor =
                age <= 16 ? true : false;
        },

        register() {
            let loader = this.$loading.show();

            axios
                .post("/api/v1/register", {
                    users: this.users,
                    privacy: this.privacy,
                    poll: this.poll,
                    locale: this.lang
                })
                .then(
                    response => {
                        window.dataLayer.push({
                            event: "registration",
                            status: "success",
                            racers: this.users.length,
                            order: response.data.order
                        });

                        //Event.$emit('order-created', response.data.order)
                        // this.view = 'payment'
                        window.location.href = response.data.redirect;
                    },
                    error => {
                        setTimeout(() => {
                            loader.hide();
                        }, 500);

                        this.errors = error.response.data.errors;

                        this.$toastr.e(this.$t("eval.all_fields"));
                    }
                );
        },

        addProduct(user, product) {
            if (!user.products.includes(product)) {
                this.$toastr.s(
                    product.name + " " + this.$t("eval.product_added")
                );

                user.products.push(product);

                dataLayer.push({
                    event: "AddToCart",
                    ecommerce: {
                        click: {
                            actionField: { Product: "Add To Cart" }, // Optional list property.
                            products: [
                                {
                                    name: product.name, // Name or ID is required.
                                    id: product.id,
                                    price: product.prices,
                                    brand: "Trkački paket",
                                    category: "kategorija",
                                    variant: "varijanta",
                                    position: "pozicija"
                                }
                            ]
                        }
                    }
                });
            } else {
                dataLayer.push({
                    event: "RemoveFromCart",
                    ecommerce: {
                        click: {
                            actionField: { Product: "Remove From Cart" }, // Optional list property.
                            products: [
                                {
                                    name: product.name, // Name or ID is required.
                                    id: product.id,
                                    price: product.prices,
                                    brand: "Trkački paket",
                                    category: "kategorija",
                                    variant: "varijanta",
                                    position: "pozicija"
                                }
                            ]
                        }
                    }
                });

                user.products.splice(user.products.indexOf(product), 1);
                this.$toastr.e(
                    product.name + " " + this.$t("eval.product_deleted")
                );
            }
        },

        userTotal(products) {
            var output = [];
            products.forEach(function(product) {
                var total = 0;
                product.prices.forEach(function(price) {
                    total = [price.price_hrk].reduce((a, b) => a + b, 0);
                });

                output += [total].reduce((a, b) => a + b, 0);
            });

            return output;
        },

        remove(price) {
            this.$swal({
                title: "Upozorenje!",
                text: "Jeste li sigurni da želite pobrisati cijenu",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                confirmButtonText: "Pobriši",
                cancelButtonText: "Odustani"
            }).then(result => {
                // <--
                if (result.value) {
                    // <-- if confirmed
                    axios
                        .delete("/admin/products-prices/" + price)
                        .then(response => {
                            console.log(response.data);
                            toastr.error("Uspiješno obrisan.");
                            this.getPrices();
                        })
                        .cache(error => {
                            toastr.error("Opaaa.");
                            console.log(response.data.error);
                        });
                }
            });
        }
    },

    computed: {
        invoiceTotal() {
            return (
                this.subTotal -
                this.subTotal * parseFloat((this.discount / 100).toFixed(2))
            );
        }
    }
};
</script>
<style>
.block:nth-child(odd) {
    background-color: #f8f8f8 !important;
}

.invalid {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #e3352f7c;
}

.invalid-border {
    border-color: #e3342f;
    padding-right: calc(1.6em + 0.75rem);
}

.multiselect__option--highlight {
    background-color: #008dd2;
}

.option__desc,
.option__image {
    display: inline-block;
    vertical-align: middle;
}

.option__image {
    max-height: 250px !important;
    margin-right: 10px;
}

.form-control {
    background-color: #f9f9f9;
    /** border-bottom: 1px solid #ccc; **/
}

.product_img {
    display: block !important;
    margin-left: auto !important;
    margin-right: auto !important;
}

.product_img:hover {
}

.product_container {
    cursor: pointer;
}

.button {
    background-color: #008dd2;
    color: #fff;
}

.product_border {
    opacity: 0.8;
}

.product_disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

.list-inline-4 li {
    padding: 0.875em 1.875em 0.875em 3.4375em;
}

.list-inline-4 li > .after {
    background: none !important;
}

.list-inline-4 li > .before {
    background: #ccc !important;
}

.list-inline-4 li > .active {
    background-color: #008dd2 !important;
}

.product_border.col-md-2.col-sm-4.col-xs-4.product_container.products_desktop:after {
    /**content: "\f00c"; **/
    background-color: #008dd2;
    font-family: "Font Awesome 5 Free";
    font-size: 26px;
    font-style: normal;
    font-weight: normal;
    position: relative;
    border-radius: 30px;
    bottom: 150px;
    color: #ffffff;
    font-weight: bold;
    padding: 5px;
    left: calc(50% - 20px);
}

.list-inline-4 li:hover {
    color: #222222 !important;
    box-shadow: 0 5px 16px 0 rgba(165, 165, 165, 0.5);
}

.products_mobile > li.active {
    border: 2px solid #0b98f6;
    background: #f8f8f8;
}

.title__divider__wrapper {
    padding-top: 3px !important;
}

.btn-inside-out {
    margin-top: 0px !important;
}

@media (min-width: 1281px) {
    .products_mobile {
        display: none;
    }
}

/*
      ##Device = Laptops, Desktops
      ##Screen = B/w 1025px to 1280px
    */

@media (min-width: 1025px) and (max-width: 1280px) {
    .products_mobile {
        display: none;
    }
}

/*
      ##Device = Tablets, Ipads (portrait)
      ##Screen = B/w 768px to 1024px
    */

@media (min-width: 768px) and (max-width: 1024px) {
    .products_desktop {
        display: none;
    }
}

@media (min-width: 481px) and (max-width: 767px) {
    .products_desktop {
        display: none;
    }

    .col-md-3 {
        padding-top: 5px !important;
        padding-bottom: 5px !important;
    }
}

/*
      ##Device = Most of the Smartphones Mobiles (Portrait)
      ##Screen = B/w 320px to 479px
    */

@media (min-width: 320px) and (max-width: 480px) {
    .products_desktop {
        display: none;
    }

    .col-md-3 {
        padding-top: 5px !important;
        padding-bottom: 5px !important;
    }
}

.delimiter-box {
    position: relative;
}

.delimiter__delimiter-solid-gradient > .before {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 3px;
    transform: translateY(-50%);
    background: radial-gradient(
        circle,
        rgba(52, 140, 210, 1) 33%,
        rgba(31, 51, 126, 1) 86%
    );
}
</style>
